import React from "react";

const TextInput = ({
  input: { name, onChange, value, type, onBlur, onFocus },
  meta: { invalid, touched },
  label,
  placeholder,
  required,
  autoComplete,
  role,
  className,
  id,
  tabIndex = 0,
  min,
  max
}) => {
  return (
    <div className={`${invalid && touched ? "has-error" : ""}`}>
      {label && <label className="form-label">{label}</label>}
      <input
        className={className}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        type={type || "text"}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete || "off"}
        role={role}
        tabIndex={tabIndex}
        min={min}
        max={max}
        onBlur={(e) => onBlur(e)}
        onFocus={(e) => onFocus(e)}
        data-1p-ignore
      />
    </div>
  );
};

export default TextInput;
